<div class="ui-g-12 px-0 mb-4">
  <div class="ui-g">
    <div class="ui-g-4 search-attachment" [ngClass]="{ 'disabled-estimate-field': isArchived || isReadyOnly}">
      <app-auto-complete id="ro-attachment-search" scrollHeight="270px" listId="ro-attachment-search-list"
        placeholder="Search attachments" [disabled]="isArchived || isReadyOnly" styleClassInput="p-0"
        leftIcon="fal fa-search pr-1" styleClassInputWrapper="p-6p" theme="border" field="title"
        [suggestions]="searchResults" [hasSearchIcon]="true" [value]="searchQuery" [autoFocus]="false"
        [isLoading]="isLoading" (appSelect)="onSearchAttachmentSelect($event)" (appClear)="onSearchClear($event)"
        (appCompletedMethod)="onSearchAttachment($event)" (appEnter)="onSearchEnter($event)">
        <ng-template let-item appTemplate="item">
          <span class="search-item d-flex">
            <div class="icon-box pl-1 mt-2">
              <i class="fal font-14" [ngClass]="{
                  'fa-file-image': item?.fileType === 'IMAGE',
                  'fa-file-pdf': item?.fileType === 'PDF',
                  'fa-file-audio': item?.fileType === 'AUDIO',
                  'fa-file-alt': item?.fileType === 'OTHER',
                  'fa-file-video': item?.fileType === 'VIDEO'
                }"></i>
            </div>
            <div class="data-box w-100 pl-2">
              <span class="font-600" tooltipStyleClass="list-tooltip" pTooltip="{{ item?.title }}"
                tooltipPosition="top">
                {{ item?.title }}
              </span>
              <span class="five-line-elipsis" style="-webkit-line-clamp: 1;" tooltipStyleClass="list-tooltip"
                pTooltip="{{ item?.category | titlecase }}" tooltipPosition="top">
                {{item?.category | titlecase}}
              </span>
            </div>
          </span>
        </ng-template>
      </app-auto-complete>
    </div>

    <div class="ui-g-1 p-0"></div>

    <div class="ui-g-7 p-0">
      <div class="attachement-action-wrapper" [ngClass]="{ 'disabled-estimate-field': isArchived || isReadyOnly}">
        <button class="btn btn-primary btn-submit font-13" (click)="handleFileBrowse(fileUpload)"
          [disabled]="isArchived || isReadyOnly || (isNewAttachmentCreationDisabled || isRefreshingList || isCreatingOrDeletingAttachment || isCheckingNewAttachmentDisabled)">
          <i class="fal fa-plus mr-4p font-white"></i>
          <span class="font-bold"
            [ngClass]="{ 'pr-2': isCreatingOrDeletingAttachment || isRefreshingList }">&nbsp;Attachment</span>
          <i class="fal fa-spinner rotate" *ngIf="isCreatingOrDeletingAttachment || isRefreshingList"></i>
        </button>
        <input type="file" (click)="fileUpload.value = ''; fileUpload.click()" class="d-none"
          (change)="onCreateAttachment($event.target.files)" #fileUpload />
      </div>
    </div>
  </div>
</div>
<div class="animated fadeIn">
  <div class="attachment-list-body ui-g-12 p-0">
    <div class="attachment-list-content ui-g-12 p-0">
      <p-table class="attachment-list" #dt [columns]="cols" [value]="attachments" [scrollable]="true" [lazy]="true"
        sortMode="off" (onLazyLoad)="onLazyLoad($event)">
        <ng-template pTemplate="header" let-columns>
          <tr class="attachment-grid-row-header">
            <th *ngFor="let col of columns" [ngClass]="col.class">
              <span>{{ col.header }}</span>
            </th>
          </tr>
        </ng-template>
        <ng-template pTemplate="body" let-rowData let-columns="columns">
          <tr class="attachment-grid-row">
            <td *ngFor="let col of columns" [ngClass]="col.class">
              <div [ngClass]="{ 'disabled-estimate-field': !isFinalizedRo && (isArchived || isReadyOnly)}" *ngIf="col.field === 'title'"
                class="edit-name">
                <p (click)="attachmentService.openAttachmentPreview({ name: rowData.name, fileType: rowData.fileType, fileExtension: rowData.fileExtension })"
                  class="text-truncate float-left mb-0 attachment-name" style="max-width: calc(100% - 50px);">
                  <i class="fal font-18 font-gray-65 mr-10" [ngClass]="{
                      'fa-file-image': rowData.fileType === 'IMAGE',
                      'fa-file-pdf': rowData.fileType === 'PDF',
                      'fa-file-audio': rowData.fileType === 'AUDIO',
                      'fa-file-alt': rowData.fileType === 'OTHER',
                      'fa-file-video': rowData.fileType === 'VIDEO'
                    }"></i>
                  <span class="pointer hover-name" pTooltip="{{ rowData[col.field] + '.' + rowData['fileExtension'] }}"
                    tooltipPosition="top">
                    {{ rowData[col.field] + '.' + rowData['fileExtension'] }}
                  </span>
                </p>
                <i class="pl-3 fal fa-edit font-18 font-gray-35 pointer"
                  [pTooltip]="isFinalizedRo && 'Sorry, cannot make any changes to a finalized RO'"
                  [ngClass]="{ 'disabled-estimate-field': isFinalizedRo}" (click)="onRenameAttachment(rowData)"></i>
              </div>

              <div *ngIf="col.field === 'category'">
                {{ rowData[col.field] | titlecase }}
              </div>

              <div *ngIf="col.field === 'fileType'" [ngClass]="{ 'text-uppercase': rowData.fileType === 'PDF' }">
                {{ rowData[col.field] | titlecase }}
              </div>

              <div *ngIf="col.field === 'date'">
                {{ rowData['createdAt'] || rowData[col.field] | date: 'MMM d, yyyy hh:mma' }}
              </div>

              <div *ngIf="col.field === 'createdBy'">
                {{ rowData[col.field] }}
              </div>

              <div *ngIf="col.field === 'isVisibleOnEstimate'">
                <app-checkbox [disabled]="rowData['category'] !== 'EXTERNAL' || isArchived || isReadyOnly"
                  (appChange)="switchEstimateVisibility(rowData._id, $event)"
                  [isChecked]="rowData['isVisibleOnEstimate']" [fontSize]="12"></app-checkbox>
              </div>

              <div *ngIf="col.field === 'isVisibleOnInvoice'">
                <app-checkbox [disabled]="rowData['category'] !== 'EXTERNAL' || isArchived || isReadyOnly"
                  (appChange)="switchInvoiceVisibility(rowData._id, $event)" [isChecked]="rowData['isVisibleOnInvoice']"
                  [fontSize]="12"></app-checkbox>
              </div>

              <div [ngClass]="{ 'disabled-estimate-field': isArchived ||isReadyOnly}" *ngIf="col.field === 'delete'"
                class="text-center">
                <i *ngIf="rowData['category'] === 'EXTERNAL'" (click)="handleAttachmentDelete(rowData._id)"
                  class="fal fa-trash-alt font-20 font-gray-35"></i>
              </div>
            </td>
          </tr>
        </ng-template>
      </p-table>

      <div *ngIf="!totalAttachments && !isLoading" class="ui-g-12 text-center not-found">
        <i class="fal fa-paperclip font-gray-75" style="transform: rotate(-45deg); font-size: 64px;"></i>
        <p class="m-0 font-gray font-12 mt-3 width-60p text-center">There are no attachments associated with RO # {{
          estimateCode }}.</p>
      </div>

      <div *ngIf="isLoading" class="ui-g-12 text-center not-found">
        Loading...
      </div>
    </div>
  </div>
</div>
